import { getJSON, getHrefParam, getGameId } from "./ultile";

export const GET_GIFT = 'recieveGift';
export const GET_GIFT_INFO = 'loadGiftList';
export const CHECK_GIFT = 'checkGift';

const GET_GIFT_INF_URL = '//www.gm99.com/mobile_serial/get_mobile_gift_game_id';
const GET_GIFT_PRE_URL = '//www.gm99.com/mobile_serial/get_public_serial_remain';
const GET_GIFT_URL = '//www.gm99.com/mobile_serial/get_mobile_serial';
const CHECK_GIFT_INF_URL = "//www.gm99.com/mobile_serial/get_mobile_serial";

const REQUEST_SUCCESS_CODE = 1;

export const UPDATE_GIFT_DETAIL = "updateGiftDetail";
export const UPDATE_GET_GIFT_RESULT = "updateGetGiftResult";
export const UPDATE_ERROR = 'updateError';

function resetGiftInitData(data) {
    return new Promise((resolve) => {
        let info = [];
        let base = data[0].data.length > 0 ? data[0].data : false;
        let pre = data[1].res.result == 1 ? data[1].data : false;
        if (data.length > 0 && !!base && !!pre) {
            for (let i = 0; i < data.length; i++) {
                info[i] = {
                    type: base[i].TYPE == 5 ? 'novice_gift' : 'member_gift',
                    name: base[i].NAME,
                    totalNum: 100
                }
            }
            info[0].less = pre['novice_gift'];
            info[0].state = pre['novice_log'] == '1' ? 0 : 1;
            info[1].less = pre['member_gift'];
            info[1].state = pre['member_log'] == '1' ? 0 : 1;
        }
        resolve(info);
    })
}

export default {
    strict: process.env.NODE_ENV !== 'production', //在非生产环境下，使用严格模式
    state: {
        giftList: [],
        getGiftSuccess: '',
        giftInfo: {
            card: '',
            content: ''
        },
        errmsg: ''
    },

    actions: {
        [GET_GIFT_INFO]({ commit }) {
            let data = {
                gameId: getGameId(),
                game_id: getGameId()
            }
            return new Promise((resolve, reject) => {
                Promise.all([getJSON(GET_GIFT_INF_URL, data), getJSON(GET_GIFT_PRE_URL, data)])
                    .then(resetGiftInitData)
                    .then((data) => {
                        commit(GET_GIFT_INFO, data)
                        resolve(data);
                    })
            })
        },
        [GET_GIFT]({ commit }, parma) {
            parma.game_id = getGameId();
            return new Promise((resolve, reject) => {
                getJSON(GET_GIFT_URL, parma)
                    .then(({ data, res, errmsg }) => {
                        if (REQUEST_SUCCESS_CODE == res.result) {
                            commit(GET_GIFT, data);
                            commit(UPDATE_GET_GIFT_RESULT, 'successPop');
                            resolve()
                        } else {
                            commit(UPDATE_GET_GIFT_RESULT, 'failGiftPop');
                            resolve();
                            //展示用的
                        }

                    })
            })
        },
        [CHECK_GIFT]({ commit }, parma) {
            let data = {
                game_id: getGameId(),
                type: parma
            }
            return new Promise((resolve, reject) => {
                getJSON(CHECK_GIFT_INF_URL, data)
                    .then(({ errmsg, data, res }) => {
                        if (REQUEST_SUCCESS_CODE == res.result) {
                            commit(GET_GIFT, data);
                            commit(UPDATE_GET_GIFT_RESULT, 'successPop');
                            resolve();
                        } else {
                            commit(UPDATE_GET_GIFT_RESULT, 'failCheckPop');
                            commit(UPDATE_ERROR, errmsg);
                            resolve();
                        }
                    })
            })
        }
    },
    mutations: {
        [GET_GIFT](state, data) {
            state.giftInfo = {
                card: data.card,
                content: data.content
            }
        },
        [GET_GIFT_INFO](state, data) {
            state.giftList = data;
        },
        [UPDATE_GET_GIFT_RESULT](state, result) {
            state.getGiftSuccess = result;
        },
        [UPDATE_ERROR](state, result) {
            state.errmsg = result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/gift.js